import { lazy, Suspense } from "react";
import { Navigate, Route, Routes, useParams } from "react-router";
import { BodyBackground } from "./face/components/BodyBackground";
import ConditionalFooter from "./face/components/ConditionalFooter";
import { AppErrorBoundary } from "./components/AppErrorBoundary";

const AccountPage = lazy(() => import("./face/account/page"));
const PrivacyPolicy = lazy(() => import("./face/privacy/page"));
const ReportPage = lazy(() => import("./face/report/[uuid]/page"));
const TermsOfService = lazy(() => import("./face/terms/page"));

function ReportRoute() {
  const { uuid = "" } = useParams();
  return <ReportPage uuid={uuid} />;
}

function RouteLoading() {
  return (
    <div className="flex min-h-svh items-center justify-center bg-white">
      <img src="/icon-transparent.svg" alt="" className="h-12 w-12" />
    </div>
  );
}

export default function App() {
  return (
    <AppErrorBoundary>
      <div className="font-sans antialiased min-h-svh flex flex-col">
        <BodyBackground />
        <div className="flex-1">
          <Suspense fallback={<RouteLoading />}>
            <Routes>
              <Route path="/report/:uuid" element={<ReportRoute />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              {/* The archive has no scan entrypoint; every other path opens the report list. */}
              <Route path="*" element={<Navigate to="/account" replace />} />
            </Routes>
          </Suspense>
        </div>
        <ConditionalFooter />
      </div>
    </AppErrorBoundary>
  );
}
